export const poc = {
  title: 'PoC Dashboard',
  subtitle: 'Select a Profile:',
  deleteData: { text: 'Delete data', title: 'Do you really want to delete your data?', url: 'Delete this user' },
  urlText: 'See footprint',
};
